import { render, staticRenderFns } from "./create-district.vue?vue&type=template&id=5aa5eaaa&"
import script from "./create-district.vue?vue&type=script&lang=js&"
export * from "./create-district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports